import styled from 'styled-components';

interface CommonTitleProps {
  title: string;
  subTitle?: string;
}

export const CommonTitle = ({ title, subTitle }: CommonTitleProps) => {
  return (
    <Title>
      <h3>{title}</h3>
      {subTitle ? <span>{subTitle}</span> : null}
    </Title>
  );
};

const Title = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-bottom: 2.4rem;
  h3 {
    font-size: 2.4rem;
    font-weight: 700;
  }
  span {
    font-size: 1.4rem;
    font-weight: 400;
    white-space: pre-line;
  }
`;
